import {
    FETCH_COST_REPORT,
    FETCH_COST_REPORT_DETAILED
} from '../actions/types';

const INITIAL_STATE = {
    costReportDetailed: {
        cost: {
            employee: {
                categories: null,
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },
            consultant: {
                categories: null,
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },
            premises: {
                categories: null,
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },
            purchase: {
                categories: null,
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },
            leasing: {
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },
            rental: {
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },
            production: {
                // month: { time_label: null, data: null },
                // quarter: { time_label: null, data: null },
                // year: { time_label: null, data: null }  
            },
            loan: {
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }  
            },
            digitalAd: {
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }  
            },            
        },
        headcount: {
            employee: {
                categories: null,
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },
            consultant: {
                categories: null,
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },            
        },
        headcount_office: {
            employee: {
                categories: null,
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },
            consultant: {
                categories: null,
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }
            },            
        },
        area: {
            premises: {
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }  
            },            
        },
        volume: {
            production: {
                month: { time_label: null, data: null },
                quarter: { time_label: null, data: null },
                year: { time_label: null, data: null }  
            },            
        }
    }
};

const costChartReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_COST_REPORT:
            return { ...state, costReport: action.payload.data };
        case FETCH_COST_REPORT_DETAILED:
            return { ...state, costReportDetailed: action.payload.data };
        default:
            return state;
    }
};

export default costChartReducer